// Auto-generated by refactor/web-routes-semantiques
// Maps semantic context names to routes (was: page IDs).

export type NavContext = "dashboard" | "paroissiens" | "profil" | "segmentation" | "sacrements" | "registres" | "intentions" | "finances" | "cloture" | "communication" | "siteweb" | "assistant-ia" | "analytics-ia" | "conseil" | "rh" | "realite-augmentee" | "domotique" | "urgences" | "innovation" | "formation" | "ecommerce" | "catalogue" | "logistique" | "calendrier" | "evenements" | "reservations" | "batiment" | "inventaire" | "vehicules" | "funerailles" | "cimetiere" | "securite" | "crises" | "energie" | "jardins" | "archives" | "administration" | "impressions" | "juridique" | "reporting" | "catechese" | "preparation-sacrements" | "formation-adultes" | "bibliotheque" | "mouvements" | "coordination-diocesaine" | "media" | "reseaux-sociaux" | "siteweb-avance" | "jumelages" | "missions" | "analytics-pastoral" | "vocations" | "labo-innovation" | "recherche-theologique" | "universite-clerge" | "supervision" | "qualite" | "feedback" | "capitalisation" | "clerge" | "cpp" | "cpae" | "comptage" | "commissions" | "agenda-cure" | "courrier" | "donateurs" | "patrimoine" | "inventaire-detail" | "stocks" | "dashboard-cure" | "dashboard-econome" | "dashboard-cpae" | "comptabilite" | "encaissements";

const contextToRoute: Record<NavContext, string> = {
  "dashboard": "/dashboard",
  "paroissiens": "/annuaire",
  "profil": "/profil",
  "segmentation": "/segmentation",
  "sacrements": "/registres",
  "registres": "/registres",
  "intentions": "/intentions",
  "finances": "/finances",
  "cloture": "/cloture",
  "communication": "/communication",
  "siteweb": "/siteweb",
  "assistant-ia": "/assistant-ia",
  "analytics-ia": "/analytics",
  "conseil": "/conseil",
  "rh": "/rh",
  "realite-augmentee": "/realite-augmentee",
  "domotique": "/domotique",
  "urgences": "/urgences",
  "innovation": "/innovation",
  "formation": "/formation",
  "ecommerce": "/ecommerce",
  "catalogue": "/catalogue",
  "logistique": "/logistique",
  "calendrier": "/calendrier",
  "evenements": "/evenements",
  "reservations": "/reservations",
  "batiment": "/batiment",
  "inventaire": "/inventaire",
  "vehicules": "/vehicules",
  "funerailles": "/funerailles",
  "cimetiere": "/cimetiere",
  "securite": "/securite",
  "crises": "/crises",
  "energie": "/energie",
  "jardins": "/jardins",
  "archives": "/archives",
  "administration": "/administration",
  "impressions": "/impressions",
  "juridique": "/juridique",
  "reporting": "/reporting",
  "catechese": "/catechese",
  "preparation-sacrements": "/preparation-sacrements",
  "formation-adultes": "/formation-adultes",
  "bibliotheque": "/bibliotheque",
  "mouvements": "/mouvements",
  "coordination-diocesaine": "/coordination-diocesaine",
  "media": "/media",
  "reseaux-sociaux": "/reseaux-sociaux",
  "siteweb-avance": "/siteweb-avance",
  "jumelages": "/jumelages",
  "missions": "/missions",
  "analytics-pastoral": "/analytics-pastoral",
  "vocations": "/vocations",
  "labo-innovation": "/labo-innovation",
  "recherche-theologique": "/recherche-theologique",
  "universite-clerge": "/universite-clerge",
  "supervision": "/supervision",
  "qualite": "/qualite",
  "feedback": "/feedback",
  "capitalisation": "/capitalisation",
  "clerge": "/clerge",
  "cpp": "/cpp",
  "cpae": "/cpae",
  "comptage": "/comptage",
  "commissions": "/commissions",
  "agenda-cure": "/agenda-cure",
  "courrier": "/courrier",
  "donateurs": "/donateurs",
  "patrimoine": "/patrimoine",
  "inventaire-detail": "/inventaire-detail",
  "stocks": "/stocks",
  "dashboard-cure": "/dashboard",
  "dashboard-econome": "/dashboard-econome",
  "dashboard-cpae": "/dashboard-cpae",
  "comptabilite": "/comptabilite",
  "encaissements": "/encaissements",
};

// Backward-compat : pageId → route (used by setLocation(getPageRoute(N)))
const idToRoute: Record<number, string> = {
  2: "/dashboard",
  3: "/annuaire",
  4: "/profil",
  5: "/segmentation",
  6: "/registres",
  7: "/intentions",
  8: "/finances",
  9: "/cloture",
  10: "/communication",
  11: "/siteweb",
  12: "/assistant-ia",
  13: "/analytics",
  14: "/conseil",
  15: "/rh",
  16: "/realite-augmentee",
  17: "/domotique",
  18: "/urgences",
  19: "/innovation",
  20: "/formation",
  21: "/ecommerce",
  22: "/catalogue",
  23: "/logistique",
  24: "/calendrier",
  25: "/evenements",
  26: "/reservations",
  27: "/batiment",
  28: "/inventaire",
  29: "/vehicules",
  30: "/funerailles",
  31: "/cimetiere",
  32: "/securite",
  33: "/crises",
  34: "/energie",
  35: "/jardins",
  36: "/archives",
  37: "/administration",
  38: "/impressions",
  39: "/juridique",
  40: "/reporting",
  41: "/catechese",
  42: "/preparation-sacrements",
  43: "/formation-adultes",
  44: "/bibliotheque",
  45: "/mouvements",
  46: "/coordination-diocesaine",
  47: "/media",
  48: "/reseaux-sociaux",
  49: "/siteweb-avance",
  50: "/jumelages",
  51: "/missions",
  52: "/analytics-pastoral",
  53: "/vocations",
  54: "/labo-innovation",
  55: "/recherche-theologique",
  56: "/universite-clerge",
  57: "/supervision",
  58: "/qualite",
  59: "/feedback",
  60: "/capitalisation",
  61: "/clerge",
  62: "/cpp",
  63: "/cpae",
  64: "/comptage",
  65: "/commissions",
  66: "/agenda-cure",
  67: "/courrier",
  68: "/donateurs",
  69: "/patrimoine",
  70: "/inventaire-detail",
  71: "/stocks",
  72: "/dashboard",
  73: "/dashboard-econome",
  74: "/dashboard-cpae",
  75: "/comptabilite",
  76: "/parametres",
  77: "/collecte",
  91: "/encaissements",
  93: "/ma-semaine",
  90: "/reversements",
  78: "/dashboard-vicaire",
  79: "/planning-liturgique",
  80: "/mariage",
  81: "/mobile-money",
  82: "/groupes-priere",
  83: "/visites-malades",
  84: "/aides-sociales",
  85: "/kermesse",
  86: "/notifications",
  87: "/portail-fidele",
  88: "/rapport-diocese",
  89: "/media/guide",
  92: "/horaires-messes",
};

export function getNavRoute(context: NavContext): string {
  return contextToRoute[context];
}

export function getPageRoute(pageId: number): string {
  return idToRoute[pageId] ?? "/dashboard";
}

/**
 * Inverse de {@link getPageRoute} : identifiant de page d'un chemin (sans la
 * chaîne de requête). Quand deux pages partagent une route (« /dashboard » :
 * 2 et 72), la plus petite l'emporte (ordre d'itération des clés entières).
 */
export function getPageIdFromPath(path: string): number | null {
  const clean = path.split("?")[0].replace(/\/+$/, "") || "/";
  for (const [id, route] of Object.entries(idToRoute)) {
    if (route === clean) return Number(id);
  }
  return null;
}

export const NAV_HOVER_CLASS = "cursor-pointer transition-all duration-200 hover:shadow-md hover:scale-[1.01] hover:border-[#3b7dd8]/30";
export const NAV_ROW_HOVER_CLASS = "cursor-pointer transition-all duration-200 hover:bg-[#3b7dd8]/5";
export const NAV_CARD_HOVER_CLASS = "cursor-pointer transition-all duration-200 hover:shadow-md hover:border-[#3b7dd8]/30 hover:-translate-y-0.5";
export const NAV_ITEM_HOVER_CLASS = "cursor-pointer transition-all duration-200 hover:bg-[#3b7dd8]/5 hover:border-[#3b7dd8]/20";

/**
 * Pages « vitrines à venir » (statut GATÉ dans docs/suivi-pages/paroisses.md) :
 * realite-augmentee (16), domotique (17), innovation (19), energie (34),
 * administration (37), impressions (38), reseaux-sociaux (48),
 * siteweb-avance (49), labo-innovation (54), recherche-theologique (55),
 * universite-clerge (56), qualite (58).
 *
 * Décision PO du 09/10/2026 : elles SORTENT DES MENUS (barre latérale et
 * explorateur de modules du tableau de bord) pour que le curé ne voie que ce
 * qui existe. Rien n'est retiré : les routes restent dans le routeur et les
 * droits dans role-permissions (un lien direct continue de fonctionner).
 */
export const COMING_SOON_PAGE_IDS: readonly number[] = [16, 17, 19, 34, 37, 38, 48, 49, 54, 55, 56, 58];

export function isComingSoonPage(pageId: number): boolean {
  return COMING_SOON_PAGE_IDS.includes(pageId);
}
